import React from 'react';

import Header from '../../layout/Header.jsx';
import ListTrades from '../../lists/ListTrades.jsx';

const PageTradesList = () => (
  <div>
    <Header>Trades</Header>
    <ListTrades />
  </div>
);

export default PageTradesList;
